import { ValidationModel } from '../../../shared/models/validation-results/validation.model';

export class DisbursementFuelTaxRequestProductModel extends ValidationModel {

    // Gets or sets the id
    public id: number;

    // Gets or sets the finance disbursement fuel tax request identifier.
    public financeDisbursementFuelTaxRequestId: number;

    // Gets or sets the product identifier.
    public productId: number;

    // Gets or sets the product name.
    public productName: number;

    // Gets or sets the amount.
    public amount: number;

    // Gets or sets the gallons.
    public fuelGallons: number;

    // Gets or sets the rate.
    public rate: number;

    constructor(json: any) {
        super(json);
        json = this.getBody();

        if (json) {
            this.id = json.id;
            this.financeDisbursementFuelTaxRequestId = json.financeDisbursementFuelTaxRequestId;
            this.productId = json.productId;
            this.productName = json.productName;
            this.amount = json.amount ? json.amount : 0;
            this.fuelGallons = json.rate ? (json.fuelGallons ? json.fuelGallons : 0) : null;
            this.rate = json.rate;
        }
    }

    /**
     * Sets the amount based on the rate and the gallons entered. Can only be set automatically if the request product has a rate.
     */
    public setAmount() {
        if (this.rate) {
            this.amount = +((this.fuelGallons * this.rate).toFixed(2));
        }
    }
}
